var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeoPointer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9562 0.626362L8.62828 15.7587C8.55836 15.9089 8.40901 16 8.25012 16C8.22523 16 8.20245 15.9978 8.17756 15.994C7.99325 15.962 7.85078 15.8075 7.83013 15.6188L7.06216 9.13281L0.354951 7.9805C0.17117 7.95068 0.0281702 7.7983 0.00327768 7.61014C-0.0194963 7.42143 0.0779553 7.23923 0.247436 7.15898L15.4001 0.0396361C15.5611 -0.0368227 15.756 -0.00103346 15.8799 0.132905C16.006 0.264132 16.0351 0.460973 15.9562 0.626362Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoPointer);
export default __webpack_public_path__ + "static/media/geoPointer.2f968b711da89c070365beb9527e71b3.svg";
export { ForwardRef as ReactComponent };